import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';
import './CauseList.css';

const CauseList = () => {
  const { hearings, cases, courts, judges } = useApp();
  const [filterDate, setFilterDate] = useState(new Date().toISOString().split('T')[0]);
  const [filterCourt, setFilterCourt] = useState('');
  const [filterJudge, setFilterJudge] = useState('');

  const filteredHearings = hearings.filter(h => {
    const matchesDate = h.hearingDate === filterDate;
    const matchesCourt = !filterCourt || h.courtId === filterCourt;
    const matchesJudge = !filterJudge || h.judgeId === filterJudge;
    return matchesDate && matchesCourt && matchesJudge && h.status === 'Scheduled';
  });

  const groupedByCourt = filteredHearings.reduce((acc, hearing) => {
    const key = hearing.courtName || 'Unknown Court';
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(hearing);
    return acc;
  }, {});

  const groupedByJudge = filteredHearings.reduce((acc, hearing) => {
    const key = hearing.judgeName || 'Unknown Judge';
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(hearing);
    return acc;
  }, {});

  return (
    <div className="cause-list-container">
      <div className="cause-list-header">
        <h1>📋 Cause List</h1>
      </div>

      <div className="cause-list-filters">
        <div className="filter-group">
          <label>Date</label>
          <input
            type="date"
            value={filterDate}
            onChange={(e) => setFilterDate(e.target.value)}
          />
        </div>

        <div className="filter-group">
          <label>Court</label>
          <select
            value={filterCourt}
            onChange={(e) => setFilterCourt(e.target.value)}
          >
            <option value="">All Courts</option>
            {courts.map(court => (
              <option key={court.id} value={court.id}>{court.courtName}</option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <label>Judge</label>
          <select
            value={filterJudge}
            onChange={(e) => setFilterJudge(e.target.value)}
          >
            <option value="">All Judges</option>
            {judges.map(judge => (
              <option key={judge.id} value={judge.id}>{judge.judgeName}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="cause-list-content">
        <div className="cause-list-section">
          <h2>Court-wise Cause List</h2>
          {Object.keys(groupedByCourt).length > 0 ? (
            Object.entries(groupedByCourt).map(([courtName, hearings]) => (
              <div key={courtName} className="cause-list-card">
                <h3>{courtName}</h3>
                <div className="cause-list-table">
                  <table>
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Case Number</th>
                        <th>Case Title</th>
                        <th>Time</th>
                        <th>Judge</th>
                        <th>Bench</th>
                      </tr>
                    </thead>
                    <tbody>
                      {hearings.sort((a, b) => a.hearingTime.localeCompare(b.hearingTime)).map((hearing, index) => (
                        <tr key={hearing.id}>
                          <td>{index + 1}</td>
                          <td><strong>{hearing.caseNumber}</strong></td>
                          <td>{hearing.caseTitle}</td>
                          <td>{hearing.hearingTime}</td>
                          <td>{hearing.judgeName}</td>
                          <td>{hearing.benchName || 'N/A'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))
          ) : (
            <p className="empty-state">No hearings scheduled for the selected date and filters.</p>
          )}
        </div>

        <div className="cause-list-section">
          <h2>Judge-wise Cause List</h2>
          {Object.keys(groupedByJudge).length > 0 ? (
            Object.entries(groupedByJudge).map(([judgeName, hearings]) => (
              <div key={judgeName} className="cause-list-card">
                <h3>{judgeName}</h3>
                <div className="cause-list-table">
                  <table>
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Case Number</th>
                        <th>Case Title</th>
                        <th>Time</th>
                        <th>Court</th>
                        <th>Bench</th>
                      </tr>
                    </thead>
                    <tbody>
                      {hearings.sort((a, b) => a.hearingTime.localeCompare(b.hearingTime)).map((hearing, index) => (
                        <tr key={hearing.id}>
                          <td>{index + 1}</td>
                          <td><strong>{hearing.caseNumber}</strong></td>
                          <td>{hearing.caseTitle}</td>
                          <td>{hearing.hearingTime}</td>
                          <td>{hearing.courtName}</td>
                          <td>{hearing.benchName || 'N/A'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))
          ) : (
            <p className="empty-state">No hearings scheduled for the selected date and filters.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CauseList;

